import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L, ModuleFE_Dialog, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import './WarningDialog.scss';
import { ICONS } from '@app/styles';
export const warningDialogTypes = ['normal', 'delete'];
export class WarningDialog extends TS_Dialog {
    // ######################## Static ########################
    static defaultProps = {
        dialogId: 'warning-dialog',
    };
    static show(options) {
        let _inProgress = false;
        options.title ??= 'Warning';
        options.executeButtonText ??= 'Save';
        options.type ??= 'normal';
        ModuleFE_Dialog.show({
            content: _jsx(WarningDialog, { className: options.type, options: options, onInProgress: inProgress => _inProgress = inProgress }),
            closeOverlayOnClick: () => !_inProgress
        });
    }
    static showDelete(options) {
        options.title ??= 'Warning';
        options.executeButtonText ??= 'Delete';
        options.type = 'delete';
        this.show(options);
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        this.props.onInProgress(false);
        return state;
    }
    // ######################## Logic ########################
    closeDialog = () => {
        if (!this.state.dialogIsBusy)
            ModuleFE_Dialog.close();
    };
    execute = async () => {
        try {
            this.props.onInProgress(true);
            this.setState({ dialogIsBusy: true });
            await this.props.options.onConfirm();
            ModuleFE_Dialog.close();
        }
        catch (err) {
            this.logError(err);
            this.setState({ dialogIsBusy: false });
        }
    };
    onCancel = () => {
        this.props.options.onCancel?.();
        this.closeDialog();
    };
    // ######################## Render ########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("span", { className: "header__title", children: this.props.options.title }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: this.closeDialog }) })] });
    };
    renderBody = () => {
        return _jsxs(_Fragment, { children: [_jsx(ICONS.attention.component, { className: 'warning-icon' }), _jsx(LL_V_L, { children: this.props.options.warningMessages.map((message, i) => _jsx("div", { className: 'dialog-main__text', children: message }, `message-${i}`)) })] });
    };
    buttons = () => {
        return {
            right: [
                { content: 'Cancel', className: 'cancel-button', onClick: this.onCancel },
                {
                    content: this.props.options.executeButtonText,
                    onClick: this.execute,
                    className: 'desired-action-button',
                    associatedKeys: ['Enter'],
                }
            ]
        };
    };
}
//# sourceMappingURL=WarningDialog.js.map